import { useState, useCallback } from 'react';
import * as positionManagementAction from "../redux/store-sarang/position/position-management.store";

export const useLookupPosition = () => {
    const [position, setPosition] = useState([]);
    const [originPosition, setOriginPosition] = useState([]);

    const getLookupPosition = useCallback(async () => {
        try {
            const res = await positionManagementAction.GetLookupPosition();
            if (res && res.content) {
                setPosition(res.content);
                setOriginPosition(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { position, setPosition, originPosition, getLookupPosition };
};
